module.exports = __webpack_public_path__ + "img/maid-cover-01.73ecf150.jpg";